/* eslint-disable @typescript-eslint/prefer-for-of */


function getPatternId(attributeValue, patternIdMap) {
    let patternId = null;
    if (attributeValue) {
        if (patternIdMap[attributeValue]) {
            patternId = attributeValue;
        } else {
            const formatedAttrValue = attributeValue
                .replace('url(', '')
                .replace(')', '')
                .replace('#', '');
            if (patternIdMap[formatedAttrValue]) {
                patternId = formatedAttrValue;
            }
        }
    }

    return patternId;
}

function getMacthedAttribute(dom, checkAttributes, patternIdMap, callback) {
    for (let i = 0; i < checkAttributes.length; i++) {
        const attributeValue = dom.getAttribute?.(checkAttributes[i]);
        const patternId = getPatternId(attributeValue, patternIdMap);
        if (patternId && callback) {
            callback({
                attribute: checkAttributes[i],
                patternId,
            });
        }
    }
}

export function recursiveReplacePatternId(dom, patternIdMap, suffix?) {
    if (!dom || !patternIdMap || Object.keys(patternIdMap).length <= 0) return;
    const childNodes = (dom?.childNodes) || [];
    for (let i = 0; i < childNodes.length; i++) {
        const node = childNodes[i];
        replacePatternId(node, patternIdMap, suffix);
        recursiveReplacePatternId(node, patternIdMap, suffix);
    }
}

export function recursiveReplacePattFillScale(dom, patternIdMap) {
    if (!dom || !patternIdMap || Object.keys(patternIdMap).length <= 0) return;
    const childNodes = (dom?.childNodes) || [];
    for (let i = 0; i < childNodes.length; i++) {
        const node = childNodes[i];
        replacePattFillScale(node, patternIdMap);
        recursiveReplacePattFillScale(node, patternIdMap);
    }
}

export function replacePattFillScale(node, patternIdMap) {
    if (!node || !patternIdMap) return;
    const attributeValue = node.getAttribute?.('mode');
    if (attributeValue === 'pattFill') {
        const patternTransformValue = `${node.getAttribute('patternTransform')?.split('scale')?.[0]} scale(3, 3)`;
        node.setAttribute('patternTransform', patternTransformValue);
    }
}

export function replacePatternId(node, patternIdMap, suffix) {
    if (!node || !patternIdMap) return;

    let handled = false;
    const checkAttributes = ['id', 'clip-path', 'fill', 'marker-start', 'marker-end', 'filter', 'mask', 'href'];
    getMacthedAttribute(node, checkAttributes, patternIdMap, (matchedAttribute) => {
        const { attribute, patternId } = matchedAttribute;
        const value = suffix && suffix.length > 0 ? `${patternIdMap[patternId]}-${suffix}` : patternIdMap[patternId];
        if (attribute === 'id') {
            node.setAttribute(attribute, value);
        } else if (attribute === 'href') {
            node.setAttribute(attribute, `#${value}`);
        } else {
            node.setAttribute(attribute, `url(#${value})`);
        }
        handled = true;
    });
    return handled;
}
